import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { MFReports } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import axiosInstance from "../../CommonMethhods/axiosInstance";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import CommonSearch from "../../CommonMethhods/CommonSearch";
import MFDuration from "../MFReports/MFDuration";
import MFTransactionHistoryReportTable from "../../Components/ReportTables/MFTransactionHistoryReportTable";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import DurationChangeComponent from "./DurationChangeComponent";

function MfTransactionHistoryReportSidebar() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorGrid, setErrorGrid] = useState(false);
  const [serverError, setServerError] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [clientCode, setClientCode] = useState("");
  const [errorResp, setErrorResp] = useState(false);
  const [selectDuration, setSelectDuration] = useState("");

    const [tableData, setTableData] = useState([]);
    const [dataCount, setDataCount] = useState();
    const [offset, setOffset] = useState(1);
    const [customShow, setCustomShow] = useState(false);
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
    // const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
    const tableBodyRef = useRef(null);

     if (fromDate == "" || toDate == "") {
        const current = new Date();
        const CurrentYear = current.getFullYear();
        const CurrentMonth = current.getMonth();
        if (CurrentMonth < 4) {
          const newYear = `04-01-${CurrentYear - 1}`;
          const date = `${current.getMonth() + 1
            }-${current.getDate()}-${current.getFullYear()}`;
          const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
          setFromDate(newYear);
          setToDate(date1);
        } else {
          const newYear = `04-01-${CurrentYear}`;
          const date = `${current.getMonth() + 1
            }-${current.getDate()}-${current.getFullYear()}`;
          const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
          setFromDate(newYear);
          setToDate(date1);
        }
      }

     const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");


  const getTransactionHistoryReport = async (fileView, offsetTab) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }

    if (fileView === "grid" && offsetTab <= 1) {
      setLoader(true);
    }

    let payloadValue = {
      userId: clientCode,
      fileType: fileView,
      pageNo: fileView === "grid" ? offsetTab : -1,
      pageSize: fileView === "grid" ? 10 : -1,
      fromDate,
      endDate: toDate,
    };

    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "encPayload");
    
    try {
      const getDetails = await axiosInstance.post(
        MFReports.Transaction_History,
        `"${encPayload}"`,
        
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setDataCount(res?.data?.totalCount);
          if (offsetTab > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.transactionHistList];
            });
          } else {
            setTableData(res?.data?.transactionHistList);
          }
          setScrollLoaderTable(false);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setTableData([]);
        if (fileView !== "grid") {
          setErrorGrid(res?.message);
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };

  const handleFromDateChange = (e) => {
    setTableData([]);
        setErrorGrid(false);
        let c = e.target.value;
        const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
        console.log(d, "datechange");
      //setTableData([]);
      setErrorGrid(false);
      setFromDate(d);
      setServerError(false);
    };
    const handleToDateChange = (e) => {
       setTableData([]);
          setErrorGrid(false);
          let c = e.target.value;
          const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
          setToDate(d);
      //setTableData([]);
      setErrorGrid(false);
      setServerError(false);
    };

    const handleOnClick = (e) => {
         setOffset(1);
    
        // if (!clientCode) {
        //   setSubmitNameError("Please Select Client Name/Code");
        //   return;
        // }
    
        if (!e.target.value) return;
    
        if (!selectDuration) {
          setErrorResp("Please Select Duration");
          return;
        }
    
        if (!compareDate(toDate)) {
          setErrorResp("Please Select To Date");
          return;
        }
    
        if (!compareDate(fromDate) || !compareDate(toDate) || !checkDateRange(fromDate, toDate)) {
          setErrorResp("Please Select Correct Date");
          return;
        }
    
        //if all good
        setErrorResp(false);
        setServerError(false);
        // setCustomShow(false)
        getTransactionHistoryReport(e.target.value, 1);

        
      };
  
  
    const handleTableScroll = (e) => {
    console.log("entered");
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoaderTable) {
      const nextOffset = offset + 1;
      const totalLoadedRecords = offset * 10;

      if (dataCount > totalLoadedRecords && dataCount !== tableData.length) {
        setOffset(nextOffset); // This still updates state for future reference
        setScrollLoaderTable(true);
        setLoader(false);
        getTransactionHistoryReport("grid", nextOffset);
      } else {
        setScrollLoaderTable(false);
      }
    }
  };
  const onChangeDuration = () => {
    setTableData([]);
    setErrorResp("")
  };
  function formatDate(date) {
      return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }  


  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">MF Transaction History Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <CommonSearch setDataCount={setDataCount}
              setClientCode={setClientCode} 
              clientCode={clientCode} />
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
              </div>
      
              {customShow && <div className="col-md-3 col-sm-3 col-6 date-width">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}

            {customShow && <div className="col-md-3  col-sm-3 col-6 date-width">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={errorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />

            </div>}
            </div>

          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
              disabled={loader || !clientCode}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            <ReportTableHeader
              showEmailBtn={false}
              showPdfBtn={false}
              smallLoaderExcel={smallLoaderExcel}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section pnl-wrapper">
            {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : 
            tableData && tableData?.length > 0 ? (
              <MFTransactionHistoryReportTable
                tableData={tableData}
                handleTableScroll={handleTableScroll}
                // hasVerticalScroll={hasVerticalScroll}
                scrollLoaderTable={scrollLoaderTable}
                loader={loader}
                LoaderForSearch={LoaderForSearch}
                ref={tableBodyRef}
                clientDashboard={false}
              />
        ) : serverError ? (
          <h4 className="report-error-message">{noDataFound(serverError)}</h4>
        ) : errorGrid && (
          noDataFound(errorGrid)
        )}
          </div>
        </div>
      </main >
    </>
  );
}

export default MfTransactionHistoryReportSidebar;
